/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAgentSessionAudioResult } from '../../models/get-agent-session-audio-result';

export interface ApiAgentsAgentIdSessionsSessionIdAudioGet$Params {
  agentId: string;
  sessionId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiAgentsAgentIdSessionsSessionIdAudioGet(http: HttpClient, rootUrl: string, params: ApiAgentsAgentIdSessionsSessionIdAudioGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionAudioResult>> {
  const rb = new RequestBuilder(rootUrl, apiAgentsAgentIdSessionsSessionIdAudioGet.PATH, 'get');
  if (params) {
    rb.path('agentId', params.agentId, {});
    rb.path('sessionId', params.sessionId, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAgentSessionAudioResult>;
    })
  );
}

apiAgentsAgentIdSessionsSessionIdAudioGet.PATH = '/api/Agents/{agentId}/sessions/{sessionId}/audio';
